export function module_main() {
  // 初期化処理をここに追加
}
